import styled from 'styled-components';
import { CalendarOutlined } from '@ant-design/icons';

import theme from '@theme';

export const Wrapper = styled.div<{
  rightBorder?: boolean;
}>`
  height: 80px;
  width: 75px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  border-right: ${({ rightBorder }) =>
    !rightBorder ? '0px solid #000' : '1px solid #000'};

  ${theme.mediaQueries.PHONE} {
    width: 100%;
  }
`;

export const Styledlabel = styled.label`
  color: #000;
  font-size: 11px;
  font-weight: 400;
  margin-bottom: 10px;
  cursor: pointer;
`;

export const Box = styled.div`
  color: gray;
  font-weight: 300;
  cursor: pointer;
  min-height: 32px;
`;

export const CalendarIcon = styled(CalendarOutlined)`
  font-size: 24px;
`;
